import { PictogramPlaceholderImages40 } from '@cian/ui-kit-design-tokens/pictograms';
import * as React from 'react';

import * as styles from './styles.css';

export const OfferGalleryEmpty: React.FC = () => {
  return (
    <div className={styles['image']}>
      <PictogramPlaceholderImages40 color="gray20_100" display="block" />
    </div>
  );
};
